'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var triggerCustomEvent = require('trigger-custom-event');
require('jquery-cookie');

var appDom = require('./app-dom');
var musicDataMgr = require('./music-data-mgr');

var cookieName = 'proofingMusicPaused';
var state;
var dom;

var setupInitialState = function() {

	state = {
		isPlaying: false,
		trackId: 0
	};

};

var setupDom = function() {

	dom = {
		musicPlayer: appDom.body.find('.music-player')
	};

};

var setSrc = function() {

	dom.musicPlayer[0].src = musicDataMgr.getTrack(state.trackId);

};

var toggleMusic = function() {

	var el = dom.musicPlayer[0];

	if (state.isPlaying) {

		el.pause();

		$.cookie(cookieName, 'true');

		triggerCustomEvent('music_paused');

	} else {

		el.play();

		$.removeCookie(cookieName);

		triggerCustomEvent('music_played');

	}

	state.isPlaying = !state.isPlaying;

};

var addEventHandlers = function() {

	appDom.document.on('main_nav_music_clicked', toggleMusic);

	dom.musicPlayer.on('ended', function() {

		console.log('audio track ended...');

		state.trackId = musicDataMgr.getNextTrack(state.trackId);

		setSrc();

		dom.musicPlayer[0].play();

	});

};

var init = function() {

	console.log('init music...');

	setupInitialState();
	setupDom();
	addEventHandlers();
	setSrc();

	// Since mobile devices ignore the autoplay attribute and we want to ignore
	// the auto play setting if the user has paused music, we'll set this value
	// appropriately on the server and pass it down to the client for processing.
	if (musicDataMgr.isAutoPlay()) {

		console.log('auto play music...');

		toggleMusic();

	}

};

module.exports = {

	init: init

};
